import { render, staticRenderFns } from "./BirthdayCard.vue?vue&type=template&id=0adb57ac&scoped=true&"
import script from "./BirthdayCard.vue?vue&type=script&lang=js&"
export * from "./BirthdayCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb57ac",
  null
  
)

export default component.exports